import { c as _slicedToArray, _ as _objectSpread2, f as _asyncToGenerator } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useContext, useState, useEffect } from 'react';
import { useResponsiveParams, SearchResultsModal } from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
import 'react-helmet';
import 'react-router-dom';
import '@apollo/client';
import './queries-3df8abcc.js';
import { L as Loading } from './loading-c16d3bd3.js';
import './queries-a3e6305b.js';

function ModalImdSearch(_ref) {
  var showImdModal = _ref.showImdModal,
      imdModalDisplay = _ref.imdModalDisplay,
      searchStringImd = _ref.searchStringImd,
      onDataUpdate = _ref.onDataUpdate,
      imdCodeOutput = _ref.imdCodeOutput,
      setImdCodeOutput = _ref.setImdCodeOutput,
      myIntermediaries = _ref.myIntermediaries,
      role = _ref.role,
      setSearchStringImd = _ref.setSearchStringImd;

  var _useContext = useContext(ConfigContext),
      branding = _useContext.branding;

  var _useState = useState({
    searchType: searchStringImd !== null && searchStringImd !== void 0 && searchStringImd.toString().match(/[a-zA-Z]/) ? 'Intermediary Name' : searchStringImd !== null && searchStringImd !== void 0 && searchStringImd.toString().match(/[0-9]/) ? 'Intermediary Code' : ''
  }),
      _useState2 = _slicedToArray(_useState, 2),
      localExistingImdValues = _useState2[0],
      setlocalExistingImdValues = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loadingImdData = _useState4[0],
      setLoadingImdData = _useState4[1];

  var colSpanParams = useResponsiveParams({
    for_mobile: {
      searchString: 5,
      searchType: 3,
      button: 1
    },
    for_desktop: {
      searchString: 3,
      searchType: 1,
      button: 1
    }
  });
  var icon_idle = /*#__PURE__*/React.createElement("img", {
    src: branding.illustration.no_data,
    alt: "no data",
    className: "lg:w-80 lg:h-80 w-64 h-64 opacity-50"
  });

  var lookupIntermediary = function lookupIntermediary(val) {
    try {
      setLoadingImdData(true);
      var filterOutput = [];

      if ((val === null || val === void 0 ? void 0 : val.searchType) === 'Intermediary Code') {
        filterOutput = myIntermediaries.filter(function (imd) {
          var _imd$intermediaryCode;

          return (imd === null || imd === void 0 ? void 0 : (_imd$intermediaryCode = imd.intermediaryCode) === null || _imd$intermediaryCode === void 0 ? void 0 : _imd$intermediaryCode.search(val === null || val === void 0 ? void 0 : val.searchString)) !== -1;
        });
      } else if ((val === null || val === void 0 ? void 0 : val.searchType) === 'Intermediary Name') {
        filterOutput = myIntermediaries.filter(function (imd) {
          var _imd$intermediaryName, _val$searchString;

          var imdName = imd === null || imd === void 0 ? void 0 : (_imd$intermediaryName = imd.intermediaryName) === null || _imd$intermediaryName === void 0 ? void 0 : _imd$intermediaryName.toLowerCase();

          if ((imdName === null || imdName === void 0 ? void 0 : imdName.search(val === null || val === void 0 ? void 0 : (_val$searchString = val.searchString) === null || _val$searchString === void 0 ? void 0 : _val$searchString.toLowerCase())) !== -1) {
            return imd;
          }
        });
      }

      setLoadingImdData(false);
      setImdCodeOutput(filterOutput);
    } catch (error) {
      setLoadingImdData(false);
    }
  };

  useEffect(function () {
    if (searchStringImd !== null && searchStringImd !== void 0 && searchStringImd.toString().match(/[a-zA-Z]/)) {
      lookupIntermediary({
        searchType: 'Intermediary Name',
        searchString: searchStringImd
      });
    } else if (searchStringImd !== null && searchStringImd !== void 0 && searchStringImd.toString().match(/[0-9]/)) {
      lookupIntermediary({
        searchType: 'Intermediary Code',
        searchString: searchStringImd
      });
    } else {
      setImdCodeOutput([]);
    }
  }, [searchStringImd]);

  var getSearchTextPlaceholder = function getSearchTextPlaceholder(searchType) {
    switch (searchType) {
      case 'Intermediary Name':
        return 'Enter Intermediary Name to search.';

      case 'Intermediary Code':
        return 'Enter Intermediary Code to search.';

      default:
        return 'Enter Intermediary Code to search.';
    }
  };

  var searchInput = {
    flow: 'cols',
    repeat: 5,
    data: [{
      type: (localExistingImdValues === null || localExistingImdValues === void 0 ? void 0 : localExistingImdValues.searchType) === 'Intermediary Code' ? 'number' : 'text',
      name: 'searchString',
      size: 'full',
      colSpan: colSpanParams.searchString,
      placeholder: getSearchTextPlaceholder(localExistingImdValues === null || localExistingImdValues === void 0 ? void 0 : localExistingImdValues.searchType),
      onDataChange: function onDataChange(val, _) {
        setlocalExistingImdValues(_objectSpread2(_objectSpread2({}, localExistingImdValues), {}, {
          searchString: val
        }));
        setSearchStringImd(val);
      }
    }, {
      type: 'select',
      name: 'searchType',
      size: 'full',
      className: 'flex flex-row justify-center items-center py-0',
      colSpan: colSpanParams.searchType,
      //   value: localExistingImdValues.searchType,
      onDataChange: function onDataChange(val, _) {
        setSearchStringImd('');
        setlocalExistingImdValues({
          searchString: '',
          searchType: val
        });
        setImdCodeOutput([]);
      },
      data: [{
        label: 'Intermediary Name',
        value: 'Intermediary Name'
      }, {
        label: 'Intermediary Code',
        value: 'Intermediary Code'
      }]
    }, {
      type: 'submit',
      size: 'full',
      colSpan: colSpanParams.button,
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSearch
      }),
      children: 'Search'
    }],
    initialValues: {
      searchString: localExistingImdValues !== null && localExistingImdValues !== void 0 && localExistingImdValues.searchString ? localExistingImdValues === null || localExistingImdValues === void 0 ? void 0 : localExistingImdValues.searchString : searchStringImd ? searchStringImd : '',
      searchType: localExistingImdValues.searchType ? localExistingImdValues.searchType : searchStringImd ? searchStringImd !== null && searchStringImd !== void 0 && searchStringImd.toString().match(/[a-zA-Z]/) //(/([a-zA-Z])?$/).test(searchStringImd)
      ? 'Intermediary Name' : searchStringImd !== null && searchStringImd !== void 0 && searchStringImd.toString().match(/[0-9]/) //(/([0-9])?$/).test(searchStringImd) 
      ? 'Intermediary Code' : '' : ''
    },
    validate: function validate(values) {
      var _role$toString, _values$searchString, _role$toString2, _role$toString3, _values$searchString2, _role$toString4;

      var errors = {};

      if (!values.searchString && (role === null || role === void 0 ? void 0 : (_role$toString = role.toString()) === null || _role$toString === void 0 ? void 0 : _role$toString.toLowerCase()) === 'underwriter') {
        errors.searchString = '* Required';
      }

      if (((_values$searchString = values.searchString) === null || _values$searchString === void 0 ? void 0 : _values$searchString.length) < 3 && (role === null || role === void 0 ? void 0 : (_role$toString2 = role.toString()) === null || _role$toString2 === void 0 ? void 0 : _role$toString2.toLowerCase()) === 'underwriter') errors.searchString = '*Minimum 3 characters Required';

      if (!values.searchString && (role === null || role === void 0 ? void 0 : (_role$toString3 = role.toString()) === null || _role$toString3 === void 0 ? void 0 : _role$toString3.toLowerCase()) === 'Internal User') {
        errors.searchString = '* Required';
      }

      if (((_values$searchString2 = values.searchString) === null || _values$searchString2 === void 0 ? void 0 : _values$searchString2.length) < 3 && (role === null || role === void 0 ? void 0 : (_role$toString4 = role.toString()) === null || _role$toString4 === void 0 ? void 0 : _role$toString4.toLowerCase()) === 'Internal User') errors.searchString = '*Minimum 3 characters Required';
      if (!values.searchType || values.searchType == undefined) errors.searchType = '* Required';
      return errors;
    },
    onSearch: function () {
      var _onSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                lookupIntermediary(values);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function onSearch(_x) {
        return _onSearch.apply(this, arguments);
      }

      return onSearch;
    }()
  };
  var searchResults = {
    data: imdCodeOutput,
    onIdle: function onIdle() {
      if (loadingImdData) {
        return /*#__PURE__*/React.createElement(Loading, null);
      } else if (searchStringImd === '') {
        return icon_idle;
      }

      return undefined;
    },
    dependencies: [localExistingImdValues === null || localExistingImdValues === void 0 ? void 0 : localExistingImdValues.searchType, localExistingImdValues === null || localExistingImdValues === void 0 ? void 0 : localExistingImdValues.searchString],
    columns: [{
      Header: 'Intermedary Code',
      accessor: 'intermediaryCode'
    }, {
      Header: 'Intermediary Name',
      accessor: 'intermediaryName'
    }],
    list: imdCodeOutput.map(function (data) {
      return {
        title: "".concat(data.intermediaryName),
        subtitle: "".concat(data.intermediaryCode),
        onClick: function onClick() {
          onDataUpdate(data);
          showImdModal(false);
          document.body.classList.remove('overflow-y-hidden');
        }
      };
    }),
    sortBy: {
      id: 'intermediaryCode',
      desc: false
    }
  };

  var onClose = function onClose() {
    showImdModal(false);
  };

  var onNoResultsFound = function onNoResultsFound() {
    return /*#__PURE__*/React.createElement("h1", null, "NO DATA FOUND");
  };

  var onMessage = function onMessage() {};

  var paginationInput = {
    offset: 0,
    PAGE_SIZE: 4
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchResultsModal, {
    modalDisplay: imdModalDisplay,
    searchInput: searchInput,
    searchResults: searchResults,
    paginationInput: paginationInput,
    title: 'Search Intermediary Code',
    onClose: onClose,
    onDataUpdate: onDataUpdate,
    onNoResultsFound: onNoResultsFound,
    onMessage: onMessage,
    selectOnRowClick: true,
    firstRowClickRequired: false
  }));
}

export { ModalImdSearch as M };
